export const DATA_CONSTANTS = {
    SET_POPULAR_GAMES: "SET_POPULAR_GAMES",
    SET_BUY_BONUS_GAMES: "SET_BUY_BONUS_GAMES",
    SET_MINI_GAMES: "SET_MINI_GAMES",
    SET_SLIDERS: "SET_SLIDERS",
    SET_SCRIPTS: "SET_SCRIPTS",
    SET_MINI_SLIDERS: "SET_MINI_SLIDERS",
    SET_MINI_BANNERS: "SET_MINI_BANNERS",
    SET_PROVIDER_LIST: "SET_PROVIDER_LIST",
    SET_VIP_STATES: "SET_VIP_STATES",
    SET_FAQS: "SET_FAQS",
    SET_BLOGS: "SET_BLOGS",
    SET_PROMOTIONS: "SET_PROMOTIONS",
    SET_HIGH_RTP_GAMES: "SET_HIGH_RTP_GAMES",
    SET_GAME_SHOWS: "SET_GAME_SHOWS",
    SET_NEW_GAMES: "SET_NEW_GAMES",
    SET_LIVE_CASINO_GAMES: "SET_LIVE_CASINO_GAMES",
    SET_TOP_GAMES: "SET_TOP_GAMES",
    SET_FREESPIN_GAMES: "SET_FREESPIN_GAMES",
    SET_JACKPOT_GAMES: "SET_JACKPOT_GAMES",
    SET_SPORTSBOOK_GAMES: "SET_SPORTSBOOK_GAMES",
};
